/**
 * @author Ariel
 * @description 查看成绩
 * @Date 2020/02/05
 */
import React from 'react'
import ReactDOM from 'react-dom'
import { connect } from 'dva'
import { modelUtils } from '../../../../utils'
import '../../../../styles/containers/online/examRecordDetail/index.less'
import { ExamPercent } from '../../../../components'
import { component_tool, framework_tool, utils_tool } from '../../../../tool'
import createGradeColumns from '../gradeExportColumns'
let {
  WizSpin,
  WizCard,
  WizRow,
  WizCol,
  WizCollapse,
  WizButton,
  WizSearchBar,
  WizDataTable,
  WizNotice,
  WizBrowserExport,
  WizBizcharts,
} = component_tool
let { WizContainer } = framework_tool
let { Session, getPageData } = utils_tool
let {
  Chart,
  Geom,
  Axis,
  Tooltip,
  Coord,
  Legend,
  Guide,
} = WizBizcharts;

import createColumns from './columns'

/**获取上一页数据作为本页参数*/
const getParamRecord = (history) => {
  let record = {}

  if (history.location) {
      if (history.location && history.location.record) {
        record = history.location.record
        Session.set('examGradeInfo', record)
      } else {
        record = Session.get('examGradeInfo') || {};
      }
  }
  return record
}

class ExamGradeInfo extends WizContainer {
  componentName = 'ExamGradeInfo';

  constructor(props) {
    super(props);
    const { history } = this.props;
    this._record = getParamRecord(history)
    this.filters = {}
    this.state = {
      modelKey: '',
      record: null,
      visible: false,
      selectedRows: 0,
      keys: [],
      rows: []
    }
  }

  propsAndStateOnChange = {
    gradeExportByPosition: this._gradeExportByPositionOver.bind(this),
    gradeExportByPositionInfo: this._gradeExportByPositionInfoOver.bind(this),
    gradeCharts: this._gradeChartsOver.bind(this),
    reviewedPaper:this._reviewedPaperOver.bind(this)
  }

  _reviewedPaperOver(nextProps, nextState) {
    if (nextProps.reviewedPaper.code === 1) {
      wizNotice.info(this.reviewedPerson+"试卷正在批阅，请稍后查询成绩")
      return true;
    } else {
      log.info(`重新阅卷失败`)
      wizNotice.error(nextProps.reviewedPaper.msg)
      return false;
    }
  }
  /**成绩信息--按选择任职导出*/
  _gradeExportByPositionOver(nextProps, nextState) {
    if (nextProps.gradeExportByPosition.code === 1) {
      let data = nextProps.gradeExportByPosition.data && nextProps.gradeExportByPosition.data.list
      data && data.length && data.forEach(element => {
        if(element.mobile !== ''&& element.mobile !== null && element.mobile !== undefined) {
            element.mobile=element.mobile.replace(/^(.{3})(?:\d+)(.{4})$/, "$1****$2");
          }
      });
      let columnDefs = createGradeColumns(this);
      WizBrowserExport({
        title: '按选择任职导出成绩',
        sheetName: '按选择任职导出成绩',
        columns: columnDefs.filter((_, index) => index),
        rows: data,
        filename: '按选择任职导出成绩.xlsx',
      })
      return true;
    } else {
      wizNotice.error('获取导出数据失败')
      return false;
    }
  }

  /**成绩信息--按任职情况导出*/
  _gradeExportByPositionInfoOver(nextProps, nextState) {
    if (nextProps.gradeExportByPositionInfo.code === 1) {
      let data = nextProps.gradeExportByPositionInfo.data && nextProps.gradeExportByPositionInfo.data.list
      data && data.length && data.forEach(element => {
        if(element.mobile !== ''&& element.mobile !== null && element.mobile !== undefined) {
            element.mobile=element.mobile.replace(/^(.{3})(?:\d+)(.{4})$/, "$1****$2");
          }
      });
      let columnDefs = createGradeColumns(this);
      WizBrowserExport({
        title: '按任职情况导出成绩',
        sheetName: '按任职情况导出成绩',
        columns: columnDefs.filter((_, index) => index),
        rows: data,
        filename: '按任职情况导出成绩.xlsx',
      })
      return true;
    } else {
      wizNotice.error('获取导出数据失败')
      return false;
    }
  }

  _componentDidMount = () => {
    this._selectExamGradeInfo(7)
  }

  /**图表数据获取情况*/
  _gradeChartsOver(nextProps, nextState) {
    let data = []
    if (nextProps.gradeCharts.code === 1) {
      data = nextProps.gradeCharts.data
      this.chartsData = data
      return true;
    } else {
      wizNotice.error('图表数据获取失败！！')
      return false;
    }
  }

  /**获取图表数据*/
  _getGradeChartsData() {
    let apiPath = "examRecord/gradeCharts";
    this.doAction({
      path: apiPath,
      payload: {
        key: 'examRecord@gradeCharts',
        apiParams: { examId: this._record.id }
      }
    })
  }

  /**成绩信息--按选择任职导出接口*/
  _selectExportByPosition(apiParams = {}) {
    let apiPath = "examRecord/gradeExportByPosition";
    this.doAction({
      path: apiPath,
      payload: {
        key: 'examRecord@gradeExportByPosition',
        apiParams: { examId: this._record.id, ...apiParams }
      }
    })
  }

  /**成绩信息--按任职情况导出接口*/
  _selectExportByPositionInfo(apiParams = {}) {
    let apiPath = "examRecord/gradeExportByPositionInfo";
    this.doAction({
      path: apiPath,
      payload: {
        key: 'examRecord@gradeExportByPositionInfo',
        apiParams: { examId: this._record.id, ...apiParams }
      }
    })
  }
  /**重新阅卷接口*/
  _reviewedPaper(apiParams = {}) {
    let apiPath = "examRecord/reviewedPaper";
    if(!this.state.keys?.length){
      wizNotice.error('必须选择一名学员！')
      return false;
    }
    this.reviewedPerson = this.state.rows?.map(value=>"【"+ (value?.fullName||'') +"】")
    ?.filter(value=>value!='').join(",")||''
    this.doAction({
      path: apiPath,
      payload: {
        key: 'examRecord@reviewedPaper',
        apiParams: { ids: this.state.keys }
      }
    })
    log.info(`state`,this.state.keys)
  }

  /**成绩信息数据接口*/
  _selectExamGradeInfo(apiParams = {}) {

    this._getGradeChartsData()
    let apiPath = "examRecord/gradePageList";
    this.doAction({
      path: apiPath,
      payload: {
        key: "examGrade" + '@' + this._record.id,
        apiParams: { current: 1, size: 10, examId: this._record.id, ...apiParams, orgId: Array.isArray(apiParams.orgId) ? null : apiParams.orgId, posId: Array.isArray(apiParams.posId) ? null : apiParams.posId }
      }
    })
  }

  /**跳转查看任职*/
  _onLookPosition(record) {
    this.jumpPage('push', '/online/examRecord/examGradeInfo/lookPositionInfo', { ...record, showAuthority: false });
  }

  _onSelect(keys, rows) {
    this.setState({
      keys,
      rows,
      selectedRows: keys.length
    })
  }

  /**
   * 渲染操作按钮 且 进行权限检查
   */
  _renderBtn = (selectedRows, key) => {
    let r = []
    let btns = new Map();
    btns.set('exportByChoosePosition', <WizButton title="按选择任职导出成绩" type="primary" onClick={() => this._selectExportByPosition(this.filters)} icon="export">按选择任职导出成绩</WizButton>);
    btns.set('exportByEmploymentInfo', <WizButton title="按任职情况导出成绩" type="primary" onClick={() => this._selectExportByPositionInfo(this.filters)} icon="export">按任职情况导出成绩</WizButton>);
    btns.set('reviewedPaper', <WizButton title="重新批阅试卷" type="primary" onClick={() => this._reviewedPaper(this.filters)} icon="sync">重新批阅试卷</WizButton>);
    let btnCode = this.getMenuBtn() || [];

    btnCode.map(({ code }) => {
      if (btns.has(code)) {
        r.push(btns.get(code))
      }
    })
    return r
  }

  _renderSearchTable(title) {
    let type = "ExamGradeInfoByExamId";
    let { record, visible, selectedRows, rows } = this.state
    let columns = createColumns(this)

    let dataItems = getPageData(this.props[type] && this.props[type].data)

    let searchBarProps = {
      columns,
      onSearch: values => {
        this.filters = values;
        this._selectExamGradeInfo(values)
        this._onSelect([], [])
      }
    }
    let dataTableProps = {
      columns,
      rowKey: 'id',
      dataItems,
      selectType: 'checkbox',
      showNum: false,
      isScroll: true,
      onChange: ({ pageNum, pageSize }) => {
        this._selectExamGradeInfo({ current: pageNum, size: pageSize, ...this.filters })
      },
      selectedRowKeys: rows.map(item => item.rowKey),
    }
    let list = dataTableProps.dataItems.list
    list && list.length && list.forEach(element => {
      if(element.mobile !== ''&& element.mobile !== null && element.mobile !== undefined) {
          element.mobile=element.mobile.replace(/^(.{3})(?:\d+)(.{4})$/, "$1****$2");
        }
    });
    return (
      <>
        <WizSearchBar key={'examGrade' + '_searchBar'} type='grid' {...searchBarProps} />
        <WizButton.WizGroup>
          {this._renderBtn(selectedRows, title)}
        </WizButton.WizGroup>
        <WizDataTable key={'examGrade' + '_dataTable'} {...dataTableProps} />
        <div className='pagination'>
          <WizDataTable.Pagination key={'examGrade' + '_pagination'} {...dataTableProps} />
        </div>
      </>
    )
  }

  _render() {
    let londing = this.props.examRecordLoading
    let examPrecent = this.chartsData ? <ExamPercent
      ref={(ref) => { this.examPercent = ref }}
      headerProps={{ title: '考试名称', value: this._record.title }}
      percentProps={{
        data: [
          {
            item: "通过人数",
            count: this.chartsData.examPassNum,
          },
          {
            item: "未通过人数",
            count: this.chartsData.examPassNotNum,
          }
        ],
        dataFormat: {
          type: "percent",
          field: "count",
          dimension: "item",
          as: "percent"
        },
        count: this.chartsData.examNum,
        centerText: '考试人数'
      }}
      itemProps={[
        { img: constants.files.sys_exam_precent_max, title: '最高分', value: this.chartsData.examMaxScore + '分' },
        { img: constants.files.sys_exam_precent_avg, title: '平均分', value: this.chartsData.examAvgScore + '分' },
        { img: constants.files.sys_exam_precent_min, title: '最低分', value: this.chartsData.examMinScore + '分' }
      ]}
    /> : null
    return (
      <>
        <WizSpin tip={"加载中"} spinning={londing}>
          <WizCard title={'成绩概况'}>
            {examPrecent}
          </WizCard>
          <WizCard title={'成绩信息'}>
            {this._renderSearchTable('成绩信息')}
          </WizCard>
        </WizSpin>
      </>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  const { examRecord } = state;
  const { history } = ownProps
  let record = getParamRecord(history)
  const ExamGradeInfoByExamId = modelUtils.getModelEntity(examRecord, 'examGrade@' + record.id);
  const gradeExportByPosition = modelUtils.getModelEntity(examRecord, "examRecord@gradeExportByPosition");
  const gradeExportByPositionInfo = modelUtils.getModelEntity(examRecord, "examRecord@gradeExportByPositionInfo");
  const gradeCharts = modelUtils.getModelEntity(examRecord, 'examRecord@gradeCharts')
  const load = modelUtils.getLoadingState(state, 'examRecord');
  const reviewedPaper = modelUtils.getModelEntity(examRecord, "examRecord@reviewedPaper");
  return {
    ExamGradeInfoByExamId,
    gradeExportByPosition,
    gradeExportByPositionInfo,
    reviewedPaper,
    gradeCharts,
    ...load
  }

};

export default connect(mapStateToProps)(ExamGradeInfo);
